import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardEditorial = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "#FFC408"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 19.3253C6 19.0296 6.2397 18.7899 6.53539 18.7899H15.1016C15.3973 18.7899 15.637 19.0296 15.637 19.3253C15.637 19.621 15.3973 19.8607 15.1016 19.8607H7.07078V19.9372C7.07078 20.9932 7.92683 21.8493 8.98287 21.8493H17.5811C17.8768 21.8493 18.1165 22.089 18.1165 22.3847C18.1165 22.6803 17.8768 22.92 17.5811 22.92H8.98287C7.33546 22.92 6 21.5846 6 19.9372V19.3253Z",
			fill: "#313B42"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.2706 22.1696C6.8174 21.8063 6.4541 20.2018 6.4541 19.4449H15.0825C15.0825 21.2614 15.5366 21.2614 16.4448 22.1696C14.3256 22.321 9.7238 22.5329 8.2706 22.1696Z",
			fill: "#313B42"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.119 12.5948C12.119 12.2991 12.3587 12.0594 12.6543 12.0594H16.9374C17.2331 12.0594 17.4728 12.2991 17.4728 12.5948C17.4728 12.8905 17.2331 13.1302 16.9374 13.1302H12.6543C12.3587 13.1302 12.119 12.8905 12.119 12.5948Z",
			fill: "#313B42"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.119 15.6541C12.119 15.3584 12.3587 15.1187 12.6543 15.1187H16.9374C17.2331 15.1187 17.4728 15.3584 17.4728 15.6541C17.4728 15.9498 17.2331 16.1895 16.9374 16.1895H12.6543C12.3587 16.1895 12.119 15.9498 12.119 15.6541Z",
			fill: "#313B42"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.6652 19.1207L25.3783 17.9307L18.7566 16.266L22.2484 22.3159L22.8709 20.2635L24.8983 21.7642C25.1919 21.9977 25.1938 21.9685 25.3811 21.6922L25.806 21.1293C26.0225 20.855 26.0446 20.8609 25.7411 20.6425L23.6652 19.1207Z",
			fill: "#313B42"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1302 10.7591C10.1302 10.3792 10.4387 10.0708 10.8186 10.0708H18.7729C19.1528 10.0708 19.4613 10.3792 19.4613 10.7591V15.0384L20.532 15.3076V10.7591C20.532 9.78784 19.7442 9 18.7729 9H10.8186C9.84728 9 9.05945 9.78784 9.05945 10.7591V19.3253C9.05945 19.621 9.29915 19.8607 9.59484 19.8607H14.5663V19.9372C14.5663 21.5846 15.9018 22.9201 17.5492 22.9201C18.6641 22.9201 19.6362 22.3084 20.1481 21.4022L19.4454 20.1847C19.324 21.1238 18.5213 21.8493 17.5492 21.8493C16.4931 21.8493 15.6371 20.9932 15.6371 19.9372V19.3253C15.6371 19.0296 15.3974 18.7899 15.1017 18.7899H10.1302V10.7591ZM19.4613 17.4868L20.532 19.3421V16.7123L19.4613 16.4431V17.4868Z",
			fill: "#313B42"
		})
	]
});
export default SvgCardEditorial;
